import React from "react";
import WhiteButton from "../../../../../Components/WhiteButton";
import { ArrowRight } from "lucide-react";

const OfferingDetailCard = ({
  title,
  description,
  imageUrl,
  left = true,
  onClick,
}) => {
  return (
    <div
      className={`flex flex-col  ${
        left ? "md:flex-row" : "md:flex-row-reverse"
      } justify-center border border-transparent hover:border-white hover:md:border-transparent transition-all ease-linear duration-300 rounded-2xl`}
      // md:space-x-16
    >
      <div
        className={`group rounded-t-2xl md:rounded-2xl overflow-hidden text-white relative shadow-lg h-[480px] min-w-[50%] flex flex-row border-2 border-transparent hover:md:border-zinc-500 transition-all ease-linear duration-300`}
      >
        <img
          src={imageUrl}
          alt="AI Strategy"
          className="w-full h-full object-cover absolute transition-all ease-linear duration-300 group-hover:scale-[101%] object-center grayscale"
        />
      </div>

      <div
        className={`flex flex-col items-start mb-6 md:mb-0 p-4 md:p-0 ${
          left ? "md:ms-16" : "md:me-16"
        }`}
      >
        <h2 className="text-base md:text-2xl font-bold font-theBrittanySans">
          {title}
        </h2>
        <p className="md:text-xl mt-2 leading-[145%] tracking-[0%] pb-6 md:pb-12 ">
          {description}
        </p>
        <WhiteButton
          text="Explore Project"
          icon={<ArrowRight />}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default OfferingDetailCard;
